var installedModules = {};
var moduleToHandlerMapping = {
	87000: {
		getter: () => (__webpack_require__.e(2176).then(() => (() => (__webpack_require__(72176))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	50846: {
		getter: () => (Promise.all([__webpack_require__.e(7012), __webpack_require__.e(6399), __webpack_require__.e(9104)]).then(() => (() => (__webpack_require__(46399))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.1.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	93416: {
		getter: () => (Promise.all([__webpack_require__.e(8911), __webpack_require__.e(7396)]).then(() => (() => (__webpack_require__(47396))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.3.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	69104: {
		getter: () => (__webpack_require__.e(3989).then(() => (() => (__webpack_require__(43989))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	13329: {
		getter: () => (__webpack_require__.e(7383).then(() => (() => (__webpack_require__(89764))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "14.1.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-i18next",
	},
	64444: {
		getter: () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(60036))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.2.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"846": [
		50846
	],
	"3416": [
		93416
	],
	"5675": [
		13329,
		64444
	],
	"7000": [
		87000
	],
	"9104": [
		69104
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}